import * as React from "react";
import {useState} from "react";
import "./tab3.scss";
import MultiSelectDropzone, {choosedFile} from "../../../../../../../../ui/dropzone/multiselect/multielectdropzone";
import NormalTab from "../../../../../../../../ui/tab/normaltab/normaltab";
import {TabFormat} from "../../../../../../../../modals/types/tab";
import Button from "../../../../../../../../core/button/button";
import StorySlider from "../../../../../../../../ui/slider/storyslider/storyslider";
import Popup from "../../../../../../../../ui/popup/popup";
import DropDown from "../../../../../../../../ui/dropdown/dropdown";
import {DropDownItem} from "../../../../../../../../modals/types/dropdown";
import Toggle from "../../../../../../../../ui/toggle/toggle";

const Tab3 = () => {
    const [selectedFiles, setSelectedFiles] = useState<choosedFile[]>([]);
    const [openPopup, setOpenPopup] = useState(false);
    const [checked, setChecked] = useState(false);
    const [showContent, setShowContent] = useState(checked);
    const templateDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}
    ];
    const utmContentDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}
    ];
    const utmTermDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}
    ];
    const scrollTabItems: TabFormat[] = [
        {
            tabs: ["آپلود عکس یا ویدیو", "لینک پست Add to story"],
            tabPanel: [
                <div className="row">
                    <div className="col-12 mb-3">
                        <MultiSelectDropzone setSelectedImages={setSelectedFiles}/>
                        <p className="gray-text font-light pt-2">
                            &#x2022;&nbsp;&nbsp;&nbsp;&nbsp;
                            فرمت عکس png, jpg باشد و حداکثر ۲۰ مگابایت باشد
                        </p>
                    </div>
                    <div className="col-12 mb-3">
                        <h6 className="pt-1 pb-1">منشن</h6>
                        <input type="text" name="" id="" className="Campaign-Input"
                               placeholder="مثال: کمپین روز مادر"/>
                    </div>
                    <div className="col-12 mb-3">
                        <h6 className="pt-1 pb-1">هشتگ</h6>
                        <input type="text" name="" id="" className="Campaign-Input"
                               placeholder="مثال: کمپین روز مادر"/>
                    </div>
                    <div className="col-12 mb-3">
                        <h6 className="pt-1 pb-1">لینک سایت شما</h6>
                        <input type="text" name="" id="" className="Campaign-Input"
                               placeholder="مثال: کمپین روز مادر"/>
                    </div>
                    <div className="col-12 mb-3">
                        <h6 className="pt-2 pb-1">سایر توضیحات</h6>
                        <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                                  rows={3}></textarea>
                    </div>
                    <div className="col-12 mb-3">
                        <Button className="d-block w-100" type={"secondary"} action={() => {
                            setOpenPopup(true);
                        }} responsive={true}>
                            مدیریت utm لینک
                        </Button>
                    </div>
                </div>,
                <div className="row">
                    <div className="col-12 mb-3">
                        <h6 className="pt-1 pb-1">لینک پست</h6>
                        <input type="text" name="" id="" className="Campaign-Input"
                               placeholder="مثال: کمپین روز مادر"/>
                    </div>
                    <div className="col-12 mb-3">
                        <h6 className="pt-1 pb-1">منشن</h6>
                        <input type="text" name="" id="" className="Campaign-Input"
                               placeholder="مثال: کمپین روز مادر"/>
                    </div>
                    <div className="col-12 mb-3">
                        <h6 className="pt-1 pb-1">هشتگ</h6>
                        <input type="text" name="" id="" className="Campaign-Input"
                               placeholder="مثال: کمپین روز مادر"/>
                    </div>
                    <div className="col-12 mb-3">
                        <h6 className="pt-2 pb-1">متن</h6>
                        <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                                  rows={3}></textarea>
                    </div>
                    <div className="col-12 mb-3">
                        <h6 className="pt-2 pb-1">سایر توضیحات</h6>
                        <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                                  rows={3}></textarea>
                    </div>
                </div>,
            ]
        }
    ]
    return (
        <div className="Tab3">
            <Popup title={"مدیریت utm لینک"} open={openPopup} setOpen={setOpenPopup} close={() => {
                setOpenPopup(false)
            }}>
                <div className="row">
                    <Toggle label={"فعال سازی utm"} checked={checked} onClick={() => setShowContent(!showContent)}/>
                    {
                        showContent ?
                            <>
                                <div className="col-lg-6 col-md-6 col-12 mb-3">
                                    <label className={"mb-2"} htmlFor="">نوع تمپلیت</label>
                                    <DropDown items={templateDropDownItems} placeHolder={"انتخاب کنید"}/>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12 mb-3">
                                    <label className={"mb-2"} htmlFor="">utm - medium</label>
                                    <input type="text" name="" id="" className="Campaign-Input"
                                           placeholder="انتخاب کنید"/>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12 mb-3">
                                    <label className={"mb-2"} htmlFor="">utm - campaign</label>
                                    <input type="text" name="" id="" className="Campaign-Input"
                                           placeholder="انتخاب کنید"/>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12 mb-3">
                                    <label className={"mb-2"} htmlFor="">utm - term</label>
                                    <DropDown items={utmTermDropDownItems} placeHolder={"انتخاب کنید"}/>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12 mb-3">
                                    <label className={"mb-2"} htmlFor="">utm - content</label>
                                    <DropDown items={utmContentDropDownItems} placeHolder={"نام نمایش دهنده"}/>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12 mb-3">
                                    <label className={"mb-2"} htmlFor="">utm - source</label>
                                    <input type="text" name="" id="" className="Campaign-Input" placeholder="teejar"/>
                                </div>
                            </>
                            :
                            null
                    }
                </div>
                <Button className="d-block mx-auto px-5" type={"primary"} action={() => {
                    setChecked(showContent);
                    setOpenPopup(false);
                }} responsive={true}>تایید</Button>
            </Popup>
            <div className="row">
                <div className="col-xl-6 col-12 mb-3">
                    <NormalTab tabs={scrollTabItems[0].tabs} tabPanel={scrollTabItems[0].tabPanel}/>
                </div>
                <div className="col-xl-6 col-12 mb-3">
                    {
                        selectedFiles.length < 2 ?
                            <img src={require("../../../../../../../../assets/images/photos/Alt.svg").default} alt=""
                                 className="img-fluid d-block mx-auto"/>
                            :
                            <StorySlider selectedFiles={selectedFiles}/>
                    }
                </div>
            </div>
        </div>
    );
}

export default Tab3;